import { action, observable } from "mobx";

const withUserData = BaseClass =>
  class extends BaseClass {
    @observable email = "";
    @observable name = "";
    @observable phoneNumber = "";

    @action.bound
    initialize(data) {
      if (super.initialize) {
        super.initialize(data);
      }

      this.email = data.email || "";
      this.name = data.name || "";
      this.phoneNumber = data.phoneNumber || "";
    }
  };

export default withUserData;
